import { render, staticRenderFns } from "./teacherprofile.vue?vue&type=template&id=0632ce04&scoped=true"
import script from "./teacherprofile.vue?vue&type=script&lang=js"
export * from "./teacherprofile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0632ce04",
  null
  
)

export default component.exports